import React from "react";
import { ListItem, ListItemButton, ListItemText, Tooltip } from "@mui/material";
import { alpha } from "@mui/material/styles";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import {
  STUDIO_ACCENT,
  STUDIO_ACCENT_DEEP,
  STUDIO_FONT,
  studioHairline,
  studioMuted,
  studioSurface,
} from "./sidebarStudioTokens";

export const SIDEBAR_RAIL_WIDTH = 72;
export const SIDEBAR_EXPANDED_WIDTH = 230;
export const SIDEBAR_MOBILE_WIDTH = 280;

/** Centra iconos de navegación en modo rail */
export const sidebarRailNavSx = {
  "& .MuiCollapse-root .MuiListItemButton-root": {
    justifyContent: "center",
    px: 1,
    py: 1.1,
    mx: 0.5,
    borderRadius: "10px",
    minHeight: 44,
  },
  "& .MuiCollapse-root .MuiListItemButton-root .MuiSvgIcon-root": {
    margin: 0,
  },
};

export function SidebarSectionHeader({
  isMinimized,
  theme,
  label,
  icon: Icon,
  iconClassName,
  open,
  onClick,
  buttonClassName,
}) {
  const mode = theme.palette.mode;
  const hairline = studioHairline(mode);

  if (isMinimized) {
    return (
      <ListItem disablePadding sx={{ px: 0.5, mb: 0.25 }}>
        <Tooltip title={label} placement="right" arrow>
          <ListItemButton
            onClick={onClick}
            className={buttonClassName}
            sx={{
              justifyContent: "center",
              minHeight: 40,
              px: 0.5,
              py: 0.75,
              borderRadius: "10px",
              border: `1px solid ${open ? STUDIO_ACCENT : hairline}`,
              bgcolor: open ? alpha(STUDIO_ACCENT, 0.18) : studioSurface(mode),
              color: open ? STUDIO_ACCENT_DEEP : studioMuted(mode),
              "&:hover": {
                bgcolor: alpha(STUDIO_ACCENT, 0.12),
                borderColor: STUDIO_ACCENT,
              },
            }}
          >
            <Icon className={iconClassName} sx={{ fontSize: 22 }} />
          </ListItemButton>
        </Tooltip>
      </ListItem>
    );
  }

  return (
    <ListItem disablePadding>
      <ListItemButton
        onClick={onClick}
        className={buttonClassName}
        sx={{
          fontFamily: STUDIO_FONT,
          "& .MuiSvgIcon-root": {
            color: studioMuted(mode),
            fontSize: 18,
          },
        }}
      >
        <ListItemText primary={label} />
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
    </ListItem>
  );
}
